/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { MetricInfoPaginatedResponse } from '../model/metricInfoPaginatedResponse';
// @ts-ignore
import { MetricInfoPatchSpec } from '../model/metricInfoPatchSpec';
// @ts-ignore
import { MetricInfoPostSpec } from '../model/metricInfoPostSpec';
// @ts-ignore
import { MetricInfoResponse } from '../model/metricInfoResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingMetricInfoOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Delete metric info by id
     * Delete metric info by id
     * @param metricInfoQueryIdRequired Metric Info Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMetricInfo(metricInfoQueryIdRequired: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<MetricInfoResponse>;
    public deleteMetricInfo(metricInfoQueryIdRequired: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MetricInfoResponse>>;
    public deleteMetricInfo(metricInfoQueryIdRequired: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MetricInfoResponse>>;
    public deleteMetricInfo(metricInfoQueryIdRequired: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (metricInfoQueryIdRequired === null || metricInfoQueryIdRequired === undefined) {
            throw new Error('Required parameter metricInfoQueryIdRequired was null or undefined when calling deleteMetricInfo.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>metricInfoQueryIdRequired, 'metric-info-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/metric-info`;
        return this.httpClient.request<MetricInfoResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all metric info by filters
     * Get all metric info by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the metric info by this column
     * @param metricInfoOptionalQueryId Metric Info Primary Key
     * @param metricNameQueryOptional Metric name
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param internalChargeIdQueryOptional Internal charge id
     * @param metricUomQueryOptional Metric Uom
     * @param odChargeIdQueryOptional OD charge id
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMetricInfo(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'metricName' | 'serviceType' | 'vcdsServiceType' | 'internalChargeId' | 'metricUom' | 'odChargeId' | 'createdTs' | 'updatedTs', metricInfoOptionalQueryId?: number, metricNameQueryOptional?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', internalChargeIdQueryOptional?: string, metricUomQueryOptional?: string, odChargeIdQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<MetricInfoPaginatedResponse>;
    public getMetricInfo(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'metricName' | 'serviceType' | 'vcdsServiceType' | 'internalChargeId' | 'metricUom' | 'odChargeId' | 'createdTs' | 'updatedTs', metricInfoOptionalQueryId?: number, metricNameQueryOptional?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', internalChargeIdQueryOptional?: string, metricUomQueryOptional?: string, odChargeIdQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MetricInfoPaginatedResponse>>;
    public getMetricInfo(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'metricName' | 'serviceType' | 'vcdsServiceType' | 'internalChargeId' | 'metricUom' | 'odChargeId' | 'createdTs' | 'updatedTs', metricInfoOptionalQueryId?: number, metricNameQueryOptional?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', internalChargeIdQueryOptional?: string, metricUomQueryOptional?: string, odChargeIdQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MetricInfoPaginatedResponse>>;
    public getMetricInfo(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'metricName' | 'serviceType' | 'vcdsServiceType' | 'internalChargeId' | 'metricUom' | 'odChargeId' | 'createdTs' | 'updatedTs', metricInfoOptionalQueryId?: number, metricNameQueryOptional?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', internalChargeIdQueryOptional?: string, metricUomQueryOptional?: string, odChargeIdQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getMetricInfo.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getMetricInfo.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>metricInfoOptionalQueryId, 'metric-info-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>metricNameQueryOptional, 'metric-name-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>internalChargeIdQueryOptional, 'internal-charge-id-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>metricUomQueryOptional, 'metric-uom-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>odChargeIdQueryOptional, 'od-charge-id-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/metric-info`;
        return this.httpClient.request<MetricInfoPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch metric info by id
     * Find and patch metric info by id
     * @param metricInfoQueryIdRequired Metric Info Primary Key
     * @param metricInfoPatchSpec Metric info patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchMetricInfo(metricInfoQueryIdRequired: number, metricInfoPatchSpec: MetricInfoPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<MetricInfoResponse>;
    public patchMetricInfo(metricInfoQueryIdRequired: number, metricInfoPatchSpec: MetricInfoPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MetricInfoResponse>>;
    public patchMetricInfo(metricInfoQueryIdRequired: number, metricInfoPatchSpec: MetricInfoPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MetricInfoResponse>>;
    public patchMetricInfo(metricInfoQueryIdRequired: number, metricInfoPatchSpec: MetricInfoPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (metricInfoQueryIdRequired === null || metricInfoQueryIdRequired === undefined) {
            throw new Error('Required parameter metricInfoQueryIdRequired was null or undefined when calling patchMetricInfo.');
        }
        if (metricInfoPatchSpec === null || metricInfoPatchSpec === undefined) {
            throw new Error('Required parameter metricInfoPatchSpec was null or undefined when calling patchMetricInfo.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>metricInfoQueryIdRequired, 'metric-info-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/metric-info`;
        return this.httpClient.request<MetricInfoResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: metricInfoPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create metric info
     * Create new metric info
     * @param metricInfoPostSpec Metric info post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postMetricInfo(metricInfoPostSpec: MetricInfoPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<MetricInfoResponse>;
    public postMetricInfo(metricInfoPostSpec: MetricInfoPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MetricInfoResponse>>;
    public postMetricInfo(metricInfoPostSpec: MetricInfoPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MetricInfoResponse>>;
    public postMetricInfo(metricInfoPostSpec: MetricInfoPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (metricInfoPostSpec === null || metricInfoPostSpec === undefined) {
            throw new Error('Required parameter metricInfoPostSpec was null or undefined when calling postMetricInfo.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/metric-info`;
        return this.httpClient.request<MetricInfoResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: metricInfoPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
